import PositionDeniedBanner from "./PositionDeniedBanner";
export default PositionDeniedBanner;